/* eslint-disable */ import { memoEval, sceneEntityAddFabComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const baseCabinetComponents = [
    attachComponent.withComponent(sceneEntityAddFabComponent, 'addWallFab', true).withAlias('BaseCabinet').withGradualFilter({
        modes: [
            'owner'
        ],
        active: (self)=>self.$noWallCabinetAbove
    }).attach(memoEval(()=>[], ()=>({
            offsetX: 12,
            offsetY: 70,
            offsetZ: 12,
            instanceNames: [
                'wallCabinetAbove'
            ],
            skipMenuWhenOnlyOne: true,
            hideWhenNone: true,
            showWhen: [
                'selected',
                'unselected'
            ],
            polarAngleLimits: {
                min: 1.4,
                max: 1.7
            },
            azimuthAngleLimits: {
                min: -0.5,
                max: 0.5
            }
        })))
];

//# sourceMappingURL=base-cabinet.js.map